const g = /^#(?:[0-9a-f]{3}){1,2}$/gi, a = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/, d = /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/g, h = /^#(?:[0-9a-f]{4}){1,2}$/gi, i = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(0|1|0?\.\d+)\)$/, r = /hsla\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%),\s*(0|1|0?\.\d+)\)/g;
function $(e, t) {
  if (e.match(g) && e.match(g).length > 0) {
    let s;
    return e.length == 4 ? s = (t * 15).toString(16) : s = (t * 255).toString(16), e + s;
  } else {
    const s = a.exec(e);
    if (s !== null)
      return `rgba(${s[1]}, ${s[2]}, ${s[3]}, ${t})`;
    const n = d.exec(e);
    if (n !== null)
      return `hsla(${n[1]}, ${n[2]}, ${n[3]}, ${t})`;
  }
  return e;
}
function l(e) {
  if (e.match(h) && e.match(h).length > 0)
    return e.length == 5 ? e.slice(0, 4) : e.slice(0, 7);
  {
    const t = i.exec(e);
    if (t !== null)
      return `rgb(${t[1]}, ${t[2]}, ${t[3]})`;
    const s = r.exec(e);
    if (s !== null)
      return `hsl(${s[1]}, ${s[2]}, ${s[3]})`;
  }
  return e;
}
export {
  $ as addOpacityToColor,
  g as hexRegex,
  h as hexWithOpacityRegex,
  d as hslRegex,
  r as hslaRegex,
  l as removeOpacityFromColor,
  a as rgbRegex,
  i as rgbaRegex
};
